import { useEffect, useState } from "react";
import { adminEndpoints } from "../../api/endpoints";

export default function useLocationInfo(
  location,
  resetParent,
  showMsg,
  apiClient,
) {
  const [newLocationName, setNewLocationName] = useState(location?.notes || "");
  const [newLocationNotes, setNewLocationNotes] = useState(
    location?.notes || "",
  );

  useEffect(() => {
    setNewLocationNotes(location?.notes || "");
    setNewLocationName(location?.name || "");
  }, [location]);

  const onSubmit = async (onSuccess) => {
    try {
      await submit(newLocationName, newLocationNotes);
      resetParent?.();
      onSuccess?.();
      showMsg?.("Informationen gespeichert.");
    } catch (error) {
      console.warn('Error in "LocationInfoModal:onSubmit"', error, error.stack);
      showMsg?.("Informationen konnten nicht gespeichert werden.");
    }
  };

  const submit = async (newLocationName, newLocationNotes) => {
    await apiClient.put(adminEndpoints.location + location.id, {
      name: newLocationName,
      notes: newLocationNotes,
    });
  };

  return {
    onSubmit,
    name: { value: newLocationName, setValue: setNewLocationName },
    notes: { value: newLocationNotes, setValue: setNewLocationNotes },
  };
}
